import { ArchiveIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { useArchivePackage } from '@/api/packages/archive-package'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'

import * as S from './archive-package-modal.styled'

export interface DeletePackageModalProps {
  packageId: number
  onClose: () => void
}

export const ArchivePackageModal = ({ packageId, onClose }: DeletePackageModalProps) => {
  const { t } = useTranslation(['packages'])
  const { mutateAsync: archivePackage, isPending } = useArchivePackage()

  const handleConfirm = async () => {
    try {
      await archivePackage({ id: packageId })
      toastFactory.success(t('packages:archivePackageModal.toastSuccess'))
      onClose()
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  return (
    <ConfirmationPopup
      autoWidth
      title={t('packages:archivePackageModal.title')}
      confirmText={t('packages:archivePackageModal.confirm')}
      cancelText={t('packages:archivePackageModal.cancel')}
      variant="warning"
      closeable={!isPending}
      closeOnOverlayClick={!isPending}
      closeOnEscapeKey={!isPending}
      confirmIcon={ArchiveIcon}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <S.Container>
        <Typography color="black700" size="heading-medium" weight="medium">
          {t('packages:archivePackageModal.body')}
        </Typography>
      </S.Container>
    </ConfirmationPopup>
  )
}
